const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 10.5003V14.5003C2 15.3303 2.67 16.0003 3.5 16.0003C4.33 16.0003 5 15.3303 5 14.5003V10.5003C5 9.67031 4.33 9.00031 3.5 9.00031C2.67 9.00031 2 9.67031 2 10.5003ZM8 10.5003V14.5003C8 15.3303 8.67 16.0003 9.5 16.0003C10.33 16.0003 11 15.3303 11 14.5003V10.5003C11 9.67031 10.33 9.00031 9.5 9.00031C8.67 9.00031 8 9.67031 8 10.5003ZM1.5 21.0003H17.5C18.33 21.0003 19 20.3303 19 19.5003C19 18.6703 18.33 18.0003 17.5 18.0003H1.5C0.67 18.0003 0 18.6703 0 19.5003C0 20.3303 0.67 21.0003 1.5 21.0003ZM14 10.5003V14.5003C14 15.3303 14.67 16.0003 15.5 16.0003C16.33 16.0003 17 15.3303 17 14.5003V10.5003C17 9.67031 16.33 9.00031 15.5 9.00031C14.67 9.00031 14 9.67031 14 10.5003ZM8.57 0.490313L0.67 4.65031C0.26 4.86031 0 5.29031 0 5.75031C0 6.44031 0.56 7.00031 1.25 7.00031H17.76C18.44 7.00031 19 6.44031 19 5.75031C19 5.29031 18.74 4.86031 18.33 4.65031L10.43 0.490313C9.85 0.180312 9.15 0.180312 8.57 0.490313Z",
  fill: "url(#paint0_linear)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -0.818056,
  y1: -7.32452,
  x2: 19.7916,
  y2: -7.16043,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.122751,
  stopColor: "#0F62FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6B5BD2"
})));
function SvgMyovens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyovens);
export default __webpack_public_path__ + "static/media/myovens.e6fc57c599f597f39d09a0b5bc50168a.svg";
export { ForwardRef as ReactComponent };